import WeekPhoto from './WeekPhotoContainer';

export default WeekPhoto;
